import { varGlobal } from "../shared/varGlobal";
import { Injectable } from "@angular/core";
import { AppSettingsService } from "./appsettings.service";
import { HttpClient } from "@angular/common/http";
import { IntlService } from "@progress/kendo-angular-intl";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

/**
 *  Service de gestion des factures (facent)
 */
@Injectable()
export class FacentService extends BehaviorSubject<any[]> {
  /** Chemin vers l'API */
  public w_baseUrl: string = "";

  /**
   * Constructeur
   */
  constructor(
    public http: HttpClient,
    public s_appsettings: AppSettingsService,
    public s_global: varGlobal,
    public s_intl: IntlService
  ) {
    super([]);
    this.w_baseUrl = this.s_global.pathAPI + "/facent";
  }

  /** Data suivante */
  public proc_next(data) {
    if (data != null) super.next(data);
    else super.next([]);
  }

  /**
   * Fonction de recuperation de tous les facent
   * Retour : json avec la liste de toutes les facents
   */
  public proc_getAll(): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/getall`,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation de toutes les facents entre deux dates
   * Retour : json avec la liste de toutes les facents reglées/non reglées
   *
   */
  public proc_getBetweenDate(
    d_start: Date,
    d_end: Date,
    regleFac: Boolean
  ): Observable<any> {
    const w_start: string = this.s_intl.formatDate(d_start, "yyyy-MM-dd");
    const w_end: string = this.s_intl.formatDate(d_end, "yyyy-MM-dd");

    return this.http.post(
      `${this.w_baseUrl}/getbetweendate`,
      JSON.stringify({
        dateMin: w_start,
        dateMax: w_end,
        regleFac: regleFac
      }),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation de toutes les facent entre 2 dates
   * Retour : json avec la liste de toutes les facents
   *
   */
  public proc_getAllBetween(d_start: Date, d_end: Date): Observable<any> {
    const w_start: string = this.s_intl.formatDate(d_start, "yyyy-MM-dd");
    const w_end: string = this.s_intl.formatDate(d_end, "yyyy-MM-dd");

    return this.http.post(
      `${this.w_baseUrl}/getall`,
      JSON.stringify({
        dateMin: w_start,
        dateMax: w_end
      }),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation d'un facent par son id
   * Parametres : facentId du facent
   * Retour : json avec le facent
   *
   */
  public proc_get(id: number): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/${id}`,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction d'ajout d'un facent dans la BDD
   * Parametres : facent a ajouter
   *
   */
  public proc_add(facent: any): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/add`,
      JSON.stringify(facent),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de mise a jour d'un facent dans la BDD
   * Parametres : facent a modifier
   *
   */
  public proc_update(facent: any): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/update`,
      JSON.stringify(facent),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation de la facture au format PDF grace a son numFacent
   * Parametres : numFacent
   * Retour : json avec byteArray de la facture en pdf
   *
   */
  public proc_getBlobFacentByNumFacent(numFacent: number): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/getBlobFacentByNumFacent`,
      numFacent,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation des factures d'un utilisateur
   * Retour : json avec liste des facent
   *
   */
  public proc_getListFacturesCurrentUser(): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/getListFacturesCurrentUser`,
      "",
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation de tous les facents avec raisonsociletiers
   * Retour : json avec la liste de tous les facents avec raisonsociletiers
   */
  public proc_getJsonFactVisu(): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/getJsonFactVisu`,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation d'un facent par raisonsocialetiers
   * Retour : json avec la liste de toutes les facents selon le raisonsocialetiers choisi
   */
  public proc_getByClient(raisonsocialetiers: string): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/getByClient`,
      JSON.stringify({
        raisonsocialetiers: raisonsocialetiers
      }),
      this.s_appsettings.proc_getHeaders()
    );
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/services/facent.service.ts